module.exports = __webpack_public_path__ + "static/media/photo3.cd1a8b6d.png";